import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

import { CommonService } from './common.service';

import { User } from '@models/user';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';


@Injectable()
export class BinaryFileService {


    constructor(private httpClient: HttpClient, private commonService: CommonService) { }


    downloadFile(binaryFileId: string) {
        return this.httpClient.get(`${environment.API_END_POINT}/binaryFile/${binaryFileId}`, { headers: this.commonService.getHeaders(), responseType: 'blob' })
            .pipe(
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    downloadReport(parameterStr: string) {
        return this.httpClient.get(`${environment.API_END_POINT}/reportFile${parameterStr}`, { headers: this.commonService.getHeaders(), responseType: 'blob' })
            .pipe(
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }
}

